import { isDerivedDose } from '~/domain/dose/derivedDose';
import { doseFrameOfReferenceUid } from '~/domain/dose/doseFrame';
import { DoseMatrix } from '~/domain/patient/doseMatrix';

export type CarriedDose =
    | { readonly status: 'none' }
    | { readonly status: 'carried'; readonly dose: DoseMatrix }
    // Not carried: the run would move it as if it were planned on the source scan.
    | { readonly status: 'otherFrame'; readonly dose: DoseMatrix };

export function resolveCarriedDose(
    doses: readonly DoseMatrix[],
    selectedSopInstanceUid: string | undefined,
    referenceDose: DoseMatrix | undefined,
    sourceFrameOfReferenceUid: string | undefined
): CarriedDose {
    const named = selectedSopInstanceUid
        ? doses.find((dose) => dose.sopInstanceUid === selectedSopInstanceUid)
        : undefined;
    // A derived dose was already mapped onto other anatomy: it is never carried again.
    const dose = named && !isDerivedDose(named) ? named : referenceDose;
    if (!dose) {
        return { status: 'none' };
    }
    // Refused rather than swapped for another dose, so the user sees which dose would have been carried.
    return sourceFrameOfReferenceUid &&
        doseFrameOfReferenceUid(dose) === sourceFrameOfReferenceUid
        ? { status: 'carried', dose }
        : { status: 'otherFrame', dose };
}
